module.exports = "<router-outlet>\n  <!-- <app-spinner></app-spinner> -->\n  <ng2-toasty [position]=\"position\"></ng2-toasty>\n</router-outlet>\n"